import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'

import { type DateTimeFormValues } from './DateTimeForm.type'

const useValidationSchema = () => {
  const { t } = useTranslation()
  return Yup.object().shape({
    jobs: Yup.array().of(Yup.object().shape({
      dateTime: Yup.object().shape({
        startDate: Yup.date().required(t('formValidation.required')),
        preferredTimRanges: Yup.array().min(1, t('formValidation.required')),
      }),
    })),
  }) as Yup.ObjectSchema<DateTimeFormValues, DateTimeFormValues>
}

export default useValidationSchema
